import { render, staticRenderFns } from "./goodsClass.vue?vue&type=template&id=049dde63&scoped=true&"
import script from "./goodsClass.vue?vue&type=script&lang=js&"
export * from "./goodsClass.vue?vue&type=script&lang=js&"
import style0 from "./goodsClass.vue?vue&type=style&index=0&id=049dde63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049dde63",
  null
  
)

export default component.exports